angular.module('dealerware.web.data').factory('DealerwareCustomerCollection', function ($filter,Collection,DealerwareCustomerModel,DataUtils) {
    'use strict';

    var baseEndpoint = '/locations/:location_id/customers';

    function useSolrSearch(params) {
        return !('all' in params.filter);
    }

    var collection = new Collection({
        baseEndpoint: baseEndpoint,
        actionOverrides: undefined,
        customActions: {
            solr_search: {
                endpoint: '/locations/:location_id/customers/solr_search',
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            },
            solr_search_with_filters: {
                endpoint: function(endpoint, args) {
                    return useSolrSearch(args.params) ? '/locations/:location_id/customers/solr_search/full' : baseEndpoint
                },
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            }
        },
        responseTransforms: {
            solr_search: mapSolrSearchResults,
            solr_search_with_filters: mapSolrSearchResults
        },
        model: 'DealerwareCustomerModel'
    });

    function mapSolrSearchResults(args, data) {
        return data.map(function (customer) {
            return angular.extend(customer, {
                data: angular.extend(customer.data, {
                    phone_number: DataUtils.getInstance().normalizePhoneNumber(customer.data.phone_number),
                    unsettled_balance_string: $filter('customCurrency')(parseFloat(customer.data.unsettled_balance) || 0)
                })
            });
        });
    }

    jQuery.extend(collection.prototype, {});

    return collection;
});